export default "__VITE_ASSET__bdacc4be__"